import { DOCUMENT, Injectable, inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ClipboardService {
  private readonly document = inject(DOCUMENT);

  public async copy(value: string): Promise<boolean> {
    const clipboard = this.document.defaultView?.navigator?.clipboard;

    if (!clipboard) {
      return false;
    }

    try {
      await clipboard.writeText(value);
      return true;
    } catch {
      return false;
    }
  }
}
